export default function () {
  if (document.getElementById('address-list-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "address-vue-app" */ '@organisms/address/main');
  }
}
